import { useFeatureMenuLazyQuery } from 'generated/sanity-graphql';
import { withLazySimpleCache } from 'state/graphql/with-simple-cache';

// Raw CMS query adapter only. Menu owns variables, fetch eligibility, settlement, and variants.
export const useCachedFeatureMenuLazyQuery = withLazySimpleCache(useFeatureMenuLazyQuery);
